// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
//import { toRem } from './utils';

// eslint-disable-next-line import/no-webpack-loader-syntax
import globalColors from '!!scss-extract-loader?{"plugins": ["scss-extract-js"]}!../../../../node_modules/@marriott/global-styles/dist/scss/base/variables/_colors.scss';

export const colors = {
  monza: '#d0021b',
  lightGrey: '#303030',
  white: globalColors['merch50'],
  carrot: globalColors['merch10'],
  grey1: '#424242',
  grey2: '#D1D1D1;',
  grey3: '#242424',
  grey4: '#616161',
  grey5: ' #646464;',
  grey6: '#707070',
  darkgrey: '#C4C4C4',
  red: '#D13438',
  brown: '#916E27',
  'dark-gray-2': globalColors['ambassadorSolid'],
  'dark-gray-3': globalColors['neutral40'],
  'base-10': globalColors['base10'],
  black: '#000000',
  neutral20: '#EEEEEE',
  coral: '#ff9662',
};
